import { Observable } from "rxjs";
import * as http from "../../../../../services/http.service";
import { BriefProductForm } from "../../../../../features/products/types/brief-product-form/brief-product-form.interface";
import { IBriefProduct } from "../../../../../types/product/ibrief-product/ibrief-product.interface";
import { SearchResults } from "../../../../../types/search/search-results.interface";

function endPoint(id: number): string {
  return `/campaign-briefs-products/${id}/products/`;
}

export function campaignBriefProductsFileDownloadEndPoint(briefId: number): string {
  return `campaign-briefs/${briefId}/product-download/`;
}

function mapProductToPost(product: number) {
  return {
    product,
    future_price: undefined,
  };
}

function mapProductsToPatch(products: BriefProductForm[]): any {
  return products.map(mapProductToPatch);
}

function mapProductToPatch(product: BriefProductForm): any {
  const { buyGetStatus, positionText, relatedGetProductIds, ...rest } = product;
  return {
    ...rest,
    position_description: positionText,
  };
}

export function addProduct(product: number, campaignBriefId: number): Observable<IBriefProduct> {
  return http.post(endPoint(campaignBriefId), mapProductToPost(product));
}

export function fetchProducts(campaignBriefId: number): Observable<SearchResults<IBriefProduct>> {
  return http.get(endPoint(campaignBriefId));
}

export function updateProducts(
  products: BriefProductForm[],
  campaignBriefId: number
): Observable<{ products: IBriefProduct[] }> {
  return http.patch(endPoint(campaignBriefId), { products: mapProductsToPatch(products) });
}
